import React, { Component } from "react";

import imgerror0 from "./assets/error0.png"
import imgerror1 from "./assets/error1.png"
import imgerror2 from "./assets/error2.png"
import imgerror3 from "./assets/error3.png"
import imgerror4 from "./assets/error4.png"
import imgerror5 from "./assets/error5.png"
import "./displayerrorslist.css"

class DisplayErrorsList extends Component 
{
    constructor(props)
    {
        super(props);
        this.imgList = [imgerror0,imgerror1,imgerror2,imgerror3,imgerror4,imgerror5];

        this.itemRefs = [];
        this.lastCurrent  = -1;
    }

    componentDidUpdate()
    {
        //console.log(this.itemRefs)
        //console.log(this.props.data)
        try
        {

            if (this.lastCurrent === this.props.current) return;
            this.lastCurrent = this.props.current;
            if ((this.itemRefs.length !== 0) && (this.props.data.length == this.itemRefs.length))
            {
                var iref = this.itemRefs[0];
                for (var i=0; i < this.itemRefs.length; i++)
                {
                    console.log(this.props.data[i].subtitleid , this.props.current-1);
                    if (this.props.data[i].subtitleid > (this.props.current-1))
                        break;
                    iref = this.itemRefs[i];
                }
                    iref.scrollIntoView({
                    behavior: "smooth",   // ou "auto"
                    block: "nearest"      // ou "center", "start", "end"
                });            
            }
        }
        catch (e){
            console.log (e)
        }
    }

    handleClick = (index) => {
        if (this.props.onClick) {
            this.props.onClick(index);
        }
    }

    render() {

        const data = this.props.data || [];
        const imgList = this.imgList;


        return (

            <div className="subtitle-list-errors" style={styles.container}>

                {data.map((item, index) => (

                    <div
                        key={item.subtitleid}
                        ref={el => this.itemRefs[index] = el}
                        onClick={() => this.handleClick(item.subtitleid)}
                        style={{
                            ...styles.item,
                            backgroundColor:
                                index % 2 === 0
                                    ? "rgba(20,20,20,0.30)"
                                    : "rgba(30,30,30,0.30)"
                        }}
                    >

                        <div style={styles.header}>

                            <span style={styles.id}>
                                {item.subtitleid+1}
                            </span>

                            <span style={styles.tc}>
                                {item.subtitletcin}
                            </span>

                            <span style={styles.tc}>
                                {item.subtitletcout}
                            </span>

                        </div>

                        {item.texts &&
                            item.texts.map((line, i) => (

                                <div
                                    key={i}
                                    style={styles.textLine}
                                >
                                    {line}
                                </div>

                            ))}

                        {item.errorlist &&
                            item.errorlist.map((err, i) => (

                                <div
                                    key={i}
                                    style={{
                                        ...styles.errorLine,
                                        color: err.bcolor,
                                        textAlign: "left"
                                    }}
                                >

                                    {imgList[err.imgindex] &&
                                        <img
                                            src={imgList[err.imgindex]}
                                            alt=""
                                            style={styles.errorImage}
                                        />
                                    }

                                    <span>
                                        {err.lib}
                                    </span>

                                </div>

                            ))}

                    </div>

                ))}

            </div>

        );
    }

}

const styles = {

    container: {

        width: "100%",
        height: "100%",
        overflowY: "auto",
        overflowX: "hidden",

        background: "transparent",

        padding: "4px",
        boxSizing: "border-box",

        fontFamily: "Arial",
        fontSize: "12px",
        color: "#D6E8FF",
        scrollbarWidth: "thin",
        scrollbarColor: "rgba(140,190,255,.3) transparent",
        

    },

    item: {

        border: "1px solid rgba(120,170,255,0.25)",
        borderRadius: "6px",

        padding: "6px",
        marginBottom: "6px",

        cursor: "pointer",

        transition: "0.15s"
    },

    header: {

        display: "flex",
        justifyContent: "space-between",

        fontWeight: "bold",

        color: "#8CC8FF",

        marginBottom: "4px"
    },

    id: {

        width: "45px",
        flexShrink: 0
    },

    tc: {

        width: "110px",
        textAlign: "center"
    },

    textLine: {

        paddingLeft: "10px",
        color: "#FFFFFF",
        lineHeight: "18px"
    },

    errorLine: {

        display: "flex",
        alignItems: "center",

        paddingLeft: "10px",
        marginTop: "2px",
        lineHeight: "18px"
    },

    errorImage: {

        width: "16px",
        height: "16px",

        marginRight: "6px",

        objectFit: "contain"
    }

};

export default DisplayErrorsList;